import SuccessfulActionModalBody from "#/shared/components/modals/SuccessfulActionModalBody"
import { ComponentStepProps } from "#/ui/Modal"

export default function LiquidityAdded({
  onClickContinue,
}: ComponentStepProps) {
  return (
    <SuccessfulActionModalBody
      title="Liquidity added!"
      description="You will find your LP NFT in your wallet."
      onClickContinue={onClickContinue}
    />
  )
}
